var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePodcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 48.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.26 186.32v27.351",
    stroke: "#0066d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.74 186.32v27.351",
    stroke: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.13 104.27v89.46m0 74.645v27.351",
    stroke: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.87 206.26v89.46m0-191.46v27.351",
    stroke: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200 127.06v145.87m0-248.68v27.351m0 296.78v27.351",
    stroke: "#fab908"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePodcast);
export default __webpack_public_path__ + "static/media/google_podcast.87587f9b89066dd9f3c5f175b4da7552.svg";
export { ForwardRef as ReactComponent };